import { cva } from '@/styled-system/css';

export const popoverHeaderRecipe = cva({
  base: {
    'display': 'flex',
    'alignItems': 'center',
    'gap': 'tighter',
    'flexGrow': 0,
    'flexShrink': 0,
    'flexBasis': 'auto',
    'paddingBlock': 'default',
    'paddingInlineStart': 'layout.tight',
    'paddingInlineEnd': 'layout.looser',
    'borderStartStartRadius': 'obj.default',
    'borderStartEndRadius': 'obj.default',
    'backgroundColor': 'bg.elevated.mediumShadow',

    '& > [data-c11n-component="Heading"]': {
      color: 'text.neutral',
      textStyle: 'body-bold',
    },

    '& [data-c11n-component="ToneIcon"]': {
      width: 'icon.md',
      height: 'icon.md',
    },
  },
  variants: {
    tone: {
      neutral: {},
      critical: {
        'backgroundColor': 'Popover.Header.bg.critical',
        '& [data-c11n-component="ToneIcon"]': {
          color: 'Popover.Header.icon.critical',
        },
      },
      info: {
        'backgroundColor': 'Popover.Header.bg.info',
        '& [data-c11n-component="ToneIcon"]': {
          color: 'Popover.Header.icon.info',
        },
      },
      success: {
        'backgroundColor': 'Popover.Header.bg.success',
        '& [data-c11n-component="ToneIcon"]': {
          color: 'icon.feedback.success.hero-alt',
        },
      },
      warning: {
        'backgroundColor': 'Popover.Header.bg.warning',
        '& [data-c11n-component="ToneIcon"]': {
          color: 'Popover.Header.icon.warning',
        },
      },
    },
  },
});
